import WithdrawFromWallet from "../../components/walletReports/withdrawFromWallet";
/**
 * WithdrawFromWalletPage
 *
 * صفحه برداشت وجه از کیف پول کاربر.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد صحیح و ساده است. استفاده از کامپوننت WithdrawFromWallet درست است.
const WithdrawFromWalletPage = () => {
  return <WithdrawFromWallet />;
};

export default WithdrawFromWalletPage;
